import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { sendError } from 'api/helpers/errors';

const showErrors = [].includes(process.env.NODE_ENV);
const reportErrors = ['staging', 'production'].includes(process.env.NODE_ENV);

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
    if (reportErrors) {
      sendError(error.toString(), errorInfo.componentStack, window.location.pathname);
    }
  }

  render() {
    const { error, errorInfo } = this.state;
    const { children } = this.props;

    if (errorInfo) {
      return (
        <div className="content-wrapper error vh_height100 align-center">
          <div className="error__message">
            <h1 className="big azure">
              <FormattedMessage id="common.Error" />
            </h1>
            <FormattedMessage id="common.error.message" />
            {showErrors && (
              <details style={{ whiteSpace: 'pre-wrap' }}>
                {error && error.toString()}
                <br />
                {errorInfo.componentStack}
              </details>
            )}
          </div>
        </div>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ErrorBoundary;
